// /*global define, console, window, HTMLImageElement, Promise*/
// (window.MyModule = function ($, Behaviors) {
//     "use strict";
//     var module = {};
//     function PostsFilters(elem) {
//         Behaviors.init(PostsFilters, this, arguments);
//         var $thisElem = this.$elem;
//         console.log('old js loaded');

//         // if( $(window).width() > 580 ) {
//             $(window).on('resize load', function(){

//                 var heights = {
//                     'full' : {}
//                 };
        
//                 $("[data-equal]").css('height', 'auto');
//                 $("[class*='data-equal-']").css('height', 'auto');
        
//                 $("[data-equal], [class*='data-equal-']").each(function(){
        
//                     var data_type = $(this).is("[class*='data-equal-']") ? 'class' : 'data';
        
//                     if( data_type == 'data' ){
//                         var $elem = $(this).attr('data-equal');
//                         var size = $(this).attr('data-equal-width');
//                     } else{
//                         var classes = this.className.split(/\s+/);
        
//                         for( var i = 0; i < classes.length; i++ ){
                            
//                             var class_name = classes[ i ];
        
//                             if( class_name.indexOf( 'data-equal-') > -1 ){
//                                 $elem = class_name.replace('data-equal-', '');
//                             }
//                             if( class_name.indexOf( 'data-equal-width-') > -1 ){
//                                 size = class_name.replace('data-equal-width-', '');
//                             }
//                         }
//                     }
        
//                     if( size == undefined )
//                         size = 'full';
        
//                     if( heights[ size ] == undefined ){
//                         heights[ size ] = {}
//                     }
        
//                     if( heights[ size ][ $elem ] == undefined ){
//                         heights[ size ][ $elem ] = 0;
//                     }
        
//                     var this_height = jQuery(this).outerHeight();
        
//                     if( this_height > heights[ size ][ $elem ] ){
//                         heights[ size ][ $elem ] = this_height;
//                     }
//                 });
        
//                 var $window_width = $(window).outerWidth();
        
//                 for( var breakpoint in heights){
//                     var element_data_value = heights[ breakpoint ];
        
//                     for( var element in element_data_value ){
        
//                         if( $window_width > parseInt(breakpoint) || breakpoint == 'full' ){
//                             $("[data-equal='"+element+"'], [class*='data-equal-"+element+"']").css('height', element_data_value[ element ]);
//                         }
//                     }
//                 }
//             });
//         // }

//         function filterTags() {
//             $thisElem.find('.PostsFilters-content_filters_dropdown_result_item_tags').html('');
//             $thisElem.find('.PostsFilters-content_filters_item input:checked').each(function (index) {
//                 $thisElem.find('.PostsFilters-content_filters_dropdown_result_item_tags').append(
//                     `<span class="filter-tag"><span class="remove-filter" data-filter="` + $(this).val() + `">` + $(this).parent().find('.PostsFilters-content_filters_item_dropdown-menu_list_item_name').text() + `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.99999 4.05732L8.29999 0.757324L9.24266 1.69999L5.94266 4.99999L9.24266 8.29999L8.29999 9.24266L4.99999 5.94266L1.69999 9.24266L0.757324 8.29999L4.05732 4.99999L0.757324 1.69999L1.69999 0.757324L4.99999 4.05732Z" fill="#121212"/></svg></span></span>`);
//             });
//         }

//         // Posts Filters Ajax
//         function resourceFilters(paged) {
//             var scrollOffset = $thisElem.offset().top - $('header').outerHeight() - 96,
//                 loop = $thisElem.find('.PostsFilters-content_main_filters_results'),
//                 location_lawn_care = '',
//                 location_lawn_issues = '',
//                 location_season = '',
//                 urlParameters = '',
//                 searchTerm = $thisElem.data('q') ? $thisElem.data('q') : '';
//                 console.log('search term ' + searchTerm);
//                 console.log('thisElem ' + $thisElem);
            
//             $thisElem.find('.PostsFilters-content_filters_item .PostsFilters-content_filters_item_form_lawn-care input:checked').each(function (index) {
//                 location_lawn_care += index > 0 ? ',' : '';
//                 location_lawn_care += $(this).val();
//             });
//             $thisElem.find('.PostsFilters-content_filters_item .PostsFilters-content_filters_item_form_lawn-issues input:checked').each(function (index) {
//                 location_lawn_issues += index > 0 ? ',' : '';
//                 location_lawn_issues += $(this).val();
//             });
//             $thisElem.find('.PostsFilters-content_filters_item .PostsFilters-content_filters_item_form_season input:checked').each(function (index) {
//                 location_season += index > 0 ? ',' : '';
//                 location_season += $(this).val();
//             });

//             //Define item in the URL
//             if (location_lawn_care.length > 0) {
//                 urlParameters += 'lawn_care=' + location_lawn_care;
//             }
//             //Define item in the URL
//             if (location_lawn_issues.length > 0) {
//                 urlParameters += location_lawn_care.length > 0 ? '&' : '';
//                 urlParameters += 'lawn_issues=' + location_lawn_issues;
//             }
//             //Define item in the URL
//             if (location_season.length > 0) {
//                 urlParameters += location_lawn_care.length > 0 || location_lawn_issues.length > 0 ? '&' : '';
//                 urlParameters += 'season=' + location_season;
//             }
            
//             //Sort
//             var sort = $thisElem.find('.PostsFilters-content-Dropdown-menu a.active').length > 0 ? $thisElem.find('.PostsFilters-content-Dropdown-menu a.active').data('sort') : '';
//             //Post Type Select data switch
//             var postCptType = $thisElem.parents('.PostsFilters').data('post');
//             // console.log(postCptType);
//             //Define URL behaviour
//             urlParameters = urlParameters ? '?' + urlParameters : '';
//             if (urlParameters.length > 0) {
//                 history.replaceState(undefined, undefined, urlParameters);
//             } else {
//                 history.replaceState(undefined, undefined, '?');
//             }

//             // if (searchTerm.length > 0) {
//             //     history.replaceState(undefined, undefined, searchTerm = '?q=' + searchTerm);
//             // } else {
//             //     history.replaceState(undefined, undefined, '?');
//             // }

//             $.ajax({
//                 url: theme_ajax_url, // AJAX handler
//                 data: {
//                     action: 'resource_filters',
//                     paged: paged,
//                     location_lawn_care: location_lawn_care,
//                     location_lawn_issues: location_lawn_issues,
//                     location_season: location_season,
//                     q: searchTerm,
//                     // filterActiveResult: filterActive,
//                     sort: sort,
//                     postCptType: postCptType
//                     // postCat: postCat,

//                 },
//                 type: 'POST',
//                 beforeSend: function (xhr) {
//                     $thisElem.addClass('SCPostsFilters-items--loading');
//                 },
//                 success: function (response) {

//                     loop.html(response);
//                     $thisElem.removeClass('SCPostsFilters-items--loading');

//                     //Change number of posts that are currently displayed on a page
//                     var countCurrentItems = $thisElem.find('.PostsFilters-content_main_filters_results_items').data('count');
//                     $thisElem.find('.PostsFilters-content-posts_count--total_displayed').text(countCurrentItems);

//                     filterTags();

//                     // Scroll to top of the products
//                     $('html, body').animate({
//                         'scrollTop': scrollOffset
//                     }, 500);
//                 }
//             });
//             return false;
//         }

//         // Remove Filter by filter item
//         $(document).on('click', '.remove-filter', function (e) {
//             e.preventDefault();
//             var $this = $(this);
//             $thisElem.find('.PostsFilters-content_filters_select_dropdowns [value="' + $this.data('filter') + '"]').prop('checked', false);
//             $this.parent().remove();
//             resourceFilters(1);
//         });

//         // Remove Filters - reset filters button
//         $(document).on('click', '#clearResourcesFiltersBtn', function (e) {
//             e.preventDefault();
//             var $this = $(this);
//             $this.hide();
//             $thisElem.find('.PostsFilters-content_filters_item_form input[type="checkbox"]').each(function(){
//                 $(this).prop('checked', false);
//             });
//             resourceFilters(1);
//         });
//         $(document).on('click', '.reset-dropdown', function (e) {
//             e.preventDefault();
//             $thisElem.find('.PostsFilters-content_filters_item_form input[type="checkbox"]').each(function(){
//                 $(this).prop('checked', false);
//             });
//             resourceFilters(1);
//         });

//         // Pagination
//         $(document).on("click", '.SCNumberPagination a', function (e) {
//             e.preventDefault();
//             var $this = $(this),
//                 paged = $(this).text(),
//                 current = parseInt($thisElem.find('.SCNumberPagination .current').text());

//             if ($this.hasClass('prev')) {
//                 paged = parseInt(current - 1);
//             } else if ($this.hasClass('next')) {
//                 paged = parseInt(current + 1);
//             }
//             resourceFilters(paged);
//         });
//         // Filter 
//         $thisElem.find('.PostsFilters-content_filters_item input[type="checkbox"]').on('change', function () {
//             resourceFilters(1);
//             if ($thisElem.find('.PostsFilters-content_filters_item input[type="checkbox"]:checked').length < 1) {
//                 $thisElem.find('.PostsFilters-content_filters_dropdown_result_reset_button').hide();
//             } else {
//                 $thisElem.find('.PostsFilters-content_filters_dropdown_result_reset_button').show();
//             };
//         });

//         if ($thisElem.find('.PostsFilters-content_filters_item input[type="checkbox"]:checked').length >= 1) {
//             $thisElem.find('.PostsFilters-content_filters_dropdown_result_reset_button').show();
//         }


//         //Sort Dropdown functionality
//         var selectItem = $('.PostsFilters-content-heading_sort_filter_heading');
//         selectItem.on('click', function(){
//             var $this = $(this);
//             if (($this.parent().hasClass('PostsFilters-content-heading_sort_filter--dropdown_active'))) {
//                 $this.parent().removeClass('PostsFilters-content-heading_sort_filter--dropdown_active');
//             } else {
//                 $this.parent().addClass('PostsFilters-content-heading_sort_filter--dropdown_active');
//             }
//         });
//         // Sorting active dropdown item
//         var dropdown = $('.PostsFilters-content-heading_sort_filter');
//         $thisElem.find('.PostsFilters-content-Dropdown-menu a').on('click', function (e) {
//             var $this = $(this);
//             var dropdownButtonText = $(this).text();
//             e.preventDefault();
//             // console.log($this.data('sort'));
//             // console.log(dropdownButtonText);
//             if(dropdownButtonText !== 'Reset Sort') {
//                 dropdown.find('.PostsFilters-content-heading_sort_filter_heading_title').text(dropdownButtonText);
//             } else {
//                 dropdown.find('.PostsFilters-content-heading_sort_filter_heading_title').text('Sort');
//             }
            
//             if (!$this.hasClass('active')) {
//                 $thisElem.find('.PostsFilters-content-Dropdown-menu a').removeClass('active');
//                 $this.addClass('active');
//             }
//             resourceFilters(1);
            
//         });


//         //Filter categories parent accordion
//         var accordionItemHeading = $('.PostsFilters-content_filters_item_dropdown-button');
//         var activeinitialContent = $('.PostsFilters-content_filters_item_dropdown-menu_list');
//         accordionItemHeading.addClass('PostsFilters-content_filters_item_dropdown-button--open');
//         activeinitialContent.slideDown();
//         accordionItemHeading.on('click', function(e) {
//             var $this = $(this);
//             e.preventDefault();
//             if($this.hasClass('PostsFilters-content_filters_item_dropdown-button--open')) {
//                 $this.siblings('.PostsFilters-content_filters_item_dropdown-menu_list').slideUp();
//                 $this.parents('.PostsFilters-content_filters_item--activate_read_more').removeClass('large-padding');
//                 $this.removeClass('PostsFilters-content_filters_item_dropdown-button--open');
//             }
//             else {
//                 $this.siblings('.PostsFilters-content_filters_item_dropdown-menu_list').slideDown();
//                 $this.addClass('PostsFilters-content_filters_item_dropdown-button--open');
//                 $this.parents('.PostsFilters-content_filters_item--activate_read_more').addClass('large-padding');
//             }
//         });

//         //Filter categories show more
//         var showMoreContainer = $('.PostsFilters-content_filters_item.PostsFilters-content_filters_item--activate_read_more .PostsFilters-content_filters_item_dropdown-menu_list');
//         var showMoreContainerButton = $('.PostsFilters-content_filters_item_dropdown-menu_list .PostsFilters-content_filters_item--read-more');
//         if(showMoreContainer.length > 0) {
//             $thisElem.find('.PostsFilters-content_filters_item').each(function(){
//                 var $this = $(this);
//                 if($this.hasClass('PostsFilters-content_filters_item--activate_read_more')) {
//                     $this.find('.PostsFilters-content_filters_item_dropdown-menu_list li').slice(0,5).addClass('shown');
//                     $this.find('.PostsFilters-content_filters_item_dropdown-menu_list li').not('.shown').hide();
//                     // If more than 5 Education items, hide the remaining
//                     showMoreContainerButton.on('click',function(e){
//                         e.preventDefault();
//                         $this.find('.PostsFilters-content_filters_item_dropdown-menu_list li').not('.shown').toggle(500);
//                         $this.find('.PostsFilters-content_filters_item--read-more').toggleClass('showLess');
//                         if($this.find('.PostsFilters-content_filters_item--read-more').hasClass('showLess')) {
//                             $this.find('.PostsFilters-content_filters_item--read-more_text').text('Show Less');    
//                         } else {
//                             $this.find('.PostsFilters-content_filters_item--read-more_text').text('Show More');
//                         }
//                     });
//                 }
//             });
//         }

//         //Mobile filter dropdown
//         if ($(window).width() < 768) {
//             $('.PostsFilters-content_filters_label_mobile').on('click', function() {
//                 var $this = $(this);
//                 $this.parents('.PostsFilters-content_main_filters_options').find('.PostsFilters-content_filters_select_dropdowns_inner').slideToggle('slow');
//                 // $this.addClass('mobile-dropdown-active');
//                 if($this.hasClass('mobile-dropdown-active')) {
//                     $this.removeClass('mobile-dropdown-active');
//                 } else {
//                     $this.addClass('mobile-dropdown-active');
//                 }
//             });
//             $('.PostsFilters-content_filters_item_dropdown-menu_list_item').on('click', function() {
//                 var $this = $(this);
//                 $this.parents('.PostsFilters-content_main_filters_options').find('.PostsFilters-content_filters_select_dropdowns_inner').slideUp('slow');
//                 $this.parents('.PostsFilters-content_main_filters_options').find('.PostsFilters-content_filters_label_mobile').removeClass('mobile-dropdown-active');
//             });
//         }
        
//         $(".PostsFilters-content-heading_sort_filter_heading").click(function (e) {
//             e.stopPropagation();
//         });

//         $(document).on('click', function() {
//             $('.PostsFilters-content-heading_sort_filter').removeClass('PostsFilters-content-heading_sort_filter--dropdown_active');
//         });

//         filterTags();

//     }
//     Behaviors.inherit(PostsFilters, Behaviors.Behavior);
//     PostsFilters.QUERY = "[data-PostsFilters]";
//     PostsFilters.ELEMENTS = {
//         loadMoreButton: ".AwardTabs-content_tabs_items_item_loadMore__button",
//     };
//     Behaviors.register_behavior(PostsFilters);
//     module.PostsFilters = PostsFilters;
//     return module;
// }(window.jQuery, window.Behaviors));
